import {forwardRef, InputHTMLAttributes, ReactNode} from 'react'
import {InputHelpText} from '@components/ui/input-help-text/InputHelpText.tsx'
import {StyledRadioInputWrapper} from '@components/commons/radio-field/style.ts'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'
import {InputRadio} from '@components/ui/input-radio/InputRadio.tsx'

export interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
    label: ReactNode
    errorMessage?: string
    helpText?: string
}

export const RadioField = forwardRef<HTMLInputElement, RadioProps>(
    ({label, helpText, errorMessage, className, ...rest}, ref) => {
        return (
            <Flexbox direction="column" gap={2} className={className}>
                <StyledRadioInputWrapper>
                    <InputRadio type="radio" ref={ref} {...rest} />
                    {typeof label === 'string' ? <p>{label}</p> : label}
                </StyledRadioInputWrapper>
                {(helpText || errorMessage) && <InputHelpText helpText={helpText} error={errorMessage} />}
            </Flexbox>
        )
    }
)

RadioField.displayName = 'RadioField'
